import { useEffect, useState } from 'react'
import { GetCbuResponse } from '../../pages/Dashboard/Api/CBU/models'
import { fetchBotCBUInformation } from '../API/AdminInfo/AdminInfo'

export const useCbuData = () => {
    const [cbuData, setCbuData] = useState<GetCbuResponse | null>(null)
    const getCbuInfo = async () => {
        const data = await fetchBotCBUInformation()
        if (data) {
            setCbuData(data)
        }
    }

    useEffect(() => {
        getCbuInfo()
    }, [])
    return { cbuData }
}
